/**
 * Reusable `head()` links descriptor for Steward light layouts. Mirrors the
 * font-loading pattern in wab.tsx (lines 24-36) but trimmed to the two families
 * app screens actually use, dropping ~80KB of marketing serifs (Fraunces /
 * Newsreader / EB Garamond). Consumed by light layouts in later clusters.
 */
export const stewardFontLinks = [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous" as const,
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400..600&family=IBM+Plex+Mono:wght@400;500&display=swap",
  },
];
